import { useEditor } from '@tiptap/react';
import { extensions } from './extensions';
import { RichTextContent } from './rich-text-content';

interface RichTextDisplayProps {
	content: string;
}

export const RichTextDisplay = ({ content }: RichTextDisplayProps) => {
	const editor = useEditor({
		content,
		extensions,
		editable: false,
	});
	return <RichTextContent editor={editor} />;
};
